// @ts-nocheck
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

export default function Layout() {
        const [sidebarShow, setSidebarShow] = useState(false);

        return (
                <div>
                        <div className={`sidebar-backdrop ${sidebarShow ? 'show' : ''}`} onClick={() => setSidebarShow(false)} aria-hidden="true" />
                        <Sidebar show={sidebarShow} onClose={() => setSidebarShow(false)} />
                        <div className="main-content">
                                <Navbar onToggleSidebar={() => setSidebarShow((s) => !s)} />
                                <div className="p-3 p-md-4">
                                        <Outlet />
                                </div>
                        </div>
                </div>
        );
}
